export const getSlateComponentProps = (slateKitProps, slateProps, componentProps) => {
    var _a, _b;
    const { context: slateKitContext } = slateKitProps;
    const { slate, context, updateComponentById, updateBlockOutput } = slateProps;
    const { componentId, parentComponentId, componentLevel } = componentProps;
    const component = slate.components[componentId];
    return {
        component,
        componentId,
        parentComponentId,
        componentLevel: componentLevel + 1,
        activated: ((_a = slateKitContext.activeBlock) === null || _a === void 0 ? void 0 : _a.id) === componentId,
        selected: ((_b = slateKitContext.selectedBlocks[0]) === null || _b === void 0 ? void 0 : _b.id) === componentId,
        output: context.blocksOutput[componentId] || {},
        updateComponent: input => updateComponentById(componentId, input),
        updateOutput: output => updateBlockOutput(componentId, output),
        updateProps: props => updateComponentById(componentId, {
            props,
        }),
        upsertProp: (key, value) => {
            updateComponentById(componentId, {
                props: Object.assign(Object.assign({}, component.props), { [key]: value }),
            });
        },
    };
};
//# sourceMappingURL=slate-component-props.utils.js.map